// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"c558d70a","498":"49166bac","598":"af6224a1","787":"d2a4fb6f"}[chunkId] + ".chunk.js";
};